/**
 * The Newly header: megamenu (hover with a short close delay + click/keyboard toggle) and the
 * mobile accordion menu. Mirrors Lovable's site-header.tsx behaviour.
 */
document.addEventListener('DOMContentLoaded', function () {
    var header = document.getElementById('masthead');
    if (!header) return;

    // ---------------- Megamenu ----------------
    var items = Array.prototype.slice.call(header.querySelectorAll('[data-mega-item]'));
    var closeTimer = null;

    function closeAll(except) {
        items.forEach(function (item) {
            if (item === except) return;
            item.classList.remove('is-open');
            var t = item.querySelector('[data-mega-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
        });
    }

    function open(item) {
        clearTimeout(closeTimer);
        closeAll(item);
        item.classList.add('is-open');
        var t = item.querySelector('[data-mega-trigger]');
        if (t) t.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { closeAll(null); }, 120);
    }

    items.forEach(function (item) {
        var trigger = item.querySelector('[data-mega-trigger]');
        var panel = item.querySelector('[data-mega-panel]');

        item.addEventListener('mouseenter', function () { open(item); });
        item.addEventListener('mouseleave', scheduleClose);
        // Review #9: the panel is a child of the item, so listening to the panel's own mouseleave
        // scheduled a close whenever the pointer moved from the panel (or its hover bridge) back up
        // into the trigger link — e.g. approaching a top-level link from below. Any movement inside
        // the item cancels a pending close instead.
        item.addEventListener('mouseover', function () { clearTimeout(closeTimer); });

        if (trigger) {
            // Keyboard / touch: first activation opens the panel, second follows the link.
            trigger.addEventListener('click', function (e) {
                var isTouchOrKey = window.matchMedia('(hover: none)').matches || e.detail === 0;
                if (isTouchOrKey && !item.classList.contains('is-open')) {
                    e.preventDefault();
                    open(item);
                }
            });
            trigger.addEventListener('focus', function () { open(item); });
        }
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mega-item]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll(null);
    });

    // ---------------- Mobile menu ----------------
    var toggle = header.querySelector('[data-mobile-toggle]');
    var menu = header.querySelector('[data-mobile-menu]');
    if (toggle && menu) {
        toggle.addEventListener('click', function () {
            var openNow = menu.hasAttribute('hidden');
            if (openNow) {
                menu.removeAttribute('hidden');
            } else {
                menu.setAttribute('hidden', '');
            }
            toggle.setAttribute('aria-expanded', openNow ? 'true' : 'false');
            toggle.setAttribute('aria-label', openNow ? 'Close menu' : 'Open menu');
        });

        menu.querySelectorAll('[data-mobile-section-toggle]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var section = btn.closest('[data-mobile-section]');
                var list = section ? section.querySelector('ul') : null;
                if (!list) return;
                var expanded = btn.getAttribute('aria-expanded') === 'true';
                // Only one section open at a time (matches Lovable).
                menu.querySelectorAll('[data-mobile-section-toggle]').forEach(function (other) {
                    if (other === btn) return;
                    other.setAttribute('aria-expanded', 'false');
                    var ol = other.closest('[data-mobile-section]').querySelector('ul');
                    if (ol) ol.setAttribute('hidden', '');
                });
                btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
                if (expanded) { list.setAttribute('hidden', ''); } else { list.removeAttribute('hidden'); }
            });
        });

        // Close the drawer after navigating.
        menu.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function () {
                menu.setAttribute('hidden', '');
                toggle.setAttribute('aria-expanded', 'false');
            });
        });
    }
});
